import request from '../utils/request';

// 获取行政区列表
export const getDistrictList = () => {
  return request({
    url: '/api/manage/getDistrictList/310000',
    method: 'get'
  });
};

// 获取地铁站列表
export const getSubwayList = () => {
  return request({
    url: '/api/manage/getSubwayList/310000',
    method: 'get'
  });
};

// 获取枚举数据
export const getEnum = (type) => {
  return request({
    url: `/api/manage/getEnum/${type}`,
    method: 'get'
  });
};
